import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetNotifications extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Notifications</h1>
				<p>This method returns a list of unread push notifications. If you provided callback URLs to get notifications, you don't need to call this method.</p>
				<p>A notification to be created when:</p>
				<ul>
					<li>
						Order
						<ul>
							<li>You received a new order.</li>
							<li>Buyer updates an order status.</li>
							<li>Items of an order are updated (added or deleted).</li>
						</ul>
					</li>
					<li>
						Message
						<ul>
							<li>You received a new message.</li>
						</ul>
					</li>
					<li>
						Feedback
						<ul>
							<li>You received a new feedback or reply.</li>
						</ul>
					</li>
				</ul>
				<p><strong>However, assure that it does not guarantee delivery of all events.</strong></p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> /notifications </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<p>Do not supply a request parameter with this method.</p>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a list of <a href="?page=resource-representations-push">push notification</a> resources as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						GET /notifications
						<ul>
							<li>Retrieves a list of unread push notifications</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}